import { useEffect, useMemo, ReactElement, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { store } from '../../../redux/store'
import authSelectors from '../../../redux/modules/auth/selectors'
import { getFromOrDefault, routes } from '../../../routes'

const AwaitEmailVerificationRoute = ({ children }: { children: ReactElement }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [ready, setReady] = useState(false)
  const { from } = (location.state || {}) as { from?: string }
  const loggedIn = useMemo(() => {
    return authSelectors.getLoggedIn(store.getState())
  }, [])
  const emailVerified = useMemo(() => {
    return authSelectors.getEmailVerified(store.getState())
  }, [])
  useEffect(() => {
    if (!loggedIn) {
      console.info('>>> AwaitEmailVerificationRoute redirect to /login')
      navigate(routes.login, {
        state: { from: from || location.pathname },
        replace: true,
      })
      return
    }
    if (emailVerified) {
      console.info('>>> AwaitEmailVerificationRoute redirect to /')
      navigate(getFromOrDefault(routes.home, from), { replace: true })
      return
    }
    setReady(true)
  }, [loggedIn, emailVerified, navigate, from, location.pathname])
  return ready ? children : null
}

export default AwaitEmailVerificationRoute
